module.exports = __webpack_public_path__ + "img/haibao.1ab37c71.png";